import React from "react";

const Shop: React.FC = () => {
  return (
    <div>
      <h1>Shop coming soon....</h1>
    </div>
  );
}

export default Shop;
